// extracted by mini-css-extract-plugin
module.exports = {"Dado":"_1iw3LSiFMchndJDaTWrdoE"};